export default "__VITE_ASSET__CZL$bBrF__"